import { render } from "./PubliCation.vue?vue&type=template&id=388904fb&scoped=true&ts=true"
import script from "./PubliCation.vue?vue&type=script&lang=ts"
export * from "./PubliCation.vue?vue&type=script&lang=ts"

import "./PubliCation.vue?vue&type=style&index=0&id=388904fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388904fb"]])

export default __exports__